import pxToRem from "../../functions/pxToRem";
import rgba from "../../functions/rgba";

export default function stepLabel({ typography, colors }) {
  const { size, fontWeightRegular } = typography;
  const { white } = colors;

  const stepLabel = {
    styleOverrides: {
      label: {
        marginTop: `${pxToRem(8)} !important`,
        fontWeight: fontWeightRegular,
        fontSize: size.xs,
        color: "#9fc9ff",
        textTransform: "uppercase",

        "&.Mui-active": {
          fontWeight: `${fontWeightRegular} !important`,
          color: `${rgba(white.main, 0.8)} !important`,
        },

        "&.Mui-completed": {
          fontWeight: `${fontWeightRegular} !important`,
          color: `${rgba(white.main, 0.8)} !important`,
        },
      },
    },
  };

  return stepLabel;
}
